// ##### 24-07-22 Komarov
import { SET_OTHERS_NAME } from '../constants';

export default (state = '', action) => {
  switch (action.type) {
    case SET_OTHERS_NAME:
      return action.payload;
    default:
      return state;
  }
};
